import { gql } from '@apollo/client';

export const ACCEPT_INTERVIEW_INVITE = gql`
  mutation AcceptInterviewInvite($input: AcceptInterviewInviteInput!) {
    acceptInterviewInvite(input: $input) {
      interviewLink {
        streamCohostToken
        streamId
      }
      interview {
        id
        interviewer {
          id
        }
      }
    }
  }
`;

export const SCHEDULE_INTERVIEW_ATTEMPT = gql`
  mutation ScheduleInterviewAttempt($input: ScheduleInterviewAttemptInput!) {
    scheduleInterviewAttempt(input: $input)
  }
`;

export const SCHEDULE_USER_INITIATED_INTERVIEW_ATTEMPT = gql`
  mutation CreateUserInitiatedInterview(
    $input: CreateUserInitiatedInterviewInput!
  ) {
    createUserInitiatedInterview(input: $input) {
      id
    }
  }
`;

export const CREATE_USER_TO_USER_INITIATE_INTERVIEW = gql`
  mutation CreateUserToUserInitiatedInterview(
    $input: CreateUserToUserInitiatedInterviewInput!
  ) {
    createUserToUserInitiatedInterview(input: $input) {
      id
    }
  }
`;

export const CANCEL_INTERVIEW = gql`
  mutation CancelInterview($input: CancelInterviewInput!) {
    cancelInterview(input: $input) {
      id
      status
    }
  }
`;

export const HOST_CANCEL_INTERVIEW = gql`
  mutation CancelInterviewByHost($input: CancelInterviewByHostInput!) {
    cancelInterviewByHost(input: $input) {
      id
      status
    }
  }
`;

export const ACCEPT_INTERVIEW_ANSWER = gql`
  mutation AcceptInterviewAnswer($input: AcceptInterviewAnswerInput!) {
    acceptInterviewAnswer(input: $input) {
      id
      postCandidateStatus
    }
  }
`;

export const REJECT_INTERVIEW_ANSWER = gql`
  mutation RejectInterviewAnswer($input: RejectInterviewAnswerInput!) {
    rejectInterviewAnswer(input: $input) {
      id
      postCandidateStatus
    }
  }
`;

export const UPDATE_INTERVIEW_INFO = gql`
  mutation UpdateInterviewInfo($input: UpdateInterviewInfoInput!) {
    updateInterviewInfo(input: $input) {
      id
      status
      stream {
        id
        mentions {
          id
          mentionType
          store {
            id
            slug
            role
            storeDetails {
              id
              storeName
              storeId
              avatarURL
            }
            firstName
            lastName
          }
          targetType
          unregisteredContact {
            id
            name
            representativeName
            phoneNumber
            type
            email
            socialMediaLink
            url
          }
        }
      }
    }
  }
`;

export const ACCEPT_ANY_AI_CLIP_CANDIDATE = gql`
  mutation AcceptAnyAiClipCandidate($input: AcceptAiClipCandidateInput!) {
    acceptAnyAiClipCandidate(input: $input) {
      id
      postCandidateStatus
    }
  }
`;

export const REJECT_ANY_AI_CLIP_CANDIDATE = gql`
  mutation RejectAnyAiClipCandidate($input: RejectAiClipCandidateInput!) {
    rejectAnyAiClipCandidate(input: $input) {
      id
      postCandidateStatus
    }
  }
`;
